import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, query, where } from "firebase/firestore";
import { Toasts } from "./helpers";
import { db } from "../firebase-config";

export async function getUserWatchHistory(userId: string) {
	const userRef = doc(db, "users", userId);
	
	const history = await getDocs(collection(userRef, "history")).then((data) => {
		return data.docs.map((doc) => ({ ...doc.data(), watch_id: doc.id }));
	});

	return history;
}

export async function addToWatchHistory(userId: string, mediaId: string, mediaType: string, watchedAt: string) {
	const userRef = doc(db, "users", userId);
	const historyRef = collection(userRef, "history");

	try {
		await addDoc(historyRef, {
			tmdb_id: mediaId,
			content_type: mediaType,
			watched_at: watchedAt,
		});
		return true;
	} catch (error) {
		return false;
	}
}

export async function removeFromWatchHistory(userId: string, watchId: string) {
	const userRef = doc(db, "users", userId);
	const historyRef = doc(userRef, "history", watchId);

	try {
		await deleteDoc(historyRef);
		return true;
	} catch (error) {
		return false;
	}
}

export async function removeAllFromWatchHistory(userId: string, tmdbId: string) {
	const userRef = doc(db, "users", userId);
	const historyRef = collection(userRef, "history");
	const q = query(historyRef, where("tmdb_id", "==", tmdbId));

	try {
		const querySnapshot = await getDocs(q);
		const deletePromises = querySnapshot.docs.map((doc) => deleteDoc(doc.ref));
		await Promise.all(deletePromises);
		return true;
	} catch (error) {
		return false;
	}
}